import { RootState } from "@app/redux/root-reducer";

export const selectFindTestDriveState = (store: RootState) =>
  store.testDriveReducer.finedTestDrive;

export const selectLocationFindAll = (store: RootState) =>
  store.testDriveReducer.locationFindAll;

export const selectOrderBookTestDriveState = (store: RootState) =>
  store.testDriveReducer.orderBookTestDrive;

export const selectUserInfoState = (store: RootState) =>
  store.testDriveReducer.userInfo;
